import sendMail from "./sendMail.js";

function sendFormPromocode() {
  $('.cart__promocode input').on('input', function() {
    if ($(this).val() !== '') {
      $(this).addClass('filled');
    } else {
      $(this).removeClass('filled');
    }
  });
  $('.cart__promocode').on('submit', function (e) {
    e.preventDefault();
      sendMail($(this)).then(() => {
        $(this).get(0).reset();
        $(this).find('button').addClass('active');
      });
  });
}
sendFormPromocode();
